var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mail_detail"},[_c('tw-mail-detail-inner',{ref:"inner",attrs:{"noticeHistoryId":_vm.noticeHistoryId,"processId":_vm.processId,"entityId":_vm.entityId,"processSeq":_vm.processSeq,"processTrx":_vm.processTrx}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }